import { cloudinary } from '@trmediaab/zebra-utils';

const mediaSizes = { full: 720, aside: 720 * (40 / 100) };

export default function transformHtml(html) {
  const reImg = /<!--data-trais([\S\s]*?)-->/gm;

  const { full, aside } = mediaSizes;

  const reLink = /<a /gi;

  const reEmptyPTags = /<p>&nbsp;<\/p>/g;

  return (
    html
      // Insert target and rel attributes to all links
      .replace(reLink, `<a target="_blank" rel="noopener noreferrer" `)
      // Remove empty p tags
      .replace(reEmptyPTags, '')
      // Replace special comments with img tags
      .replace(reImg, (match, p) => {
        try {
          // Parse content inside comment
          const {
            type,
            alt,
            view_mode: viewMode,
            cdn_id: imageId,
          } = JSON.parse(p);
          if (type !== 'image') {
            throw new Error(`The data-trais type '${type}' is unknown`);
          }

          const scaledWidth = viewMode === 'side' ? aside : full;

          const src = cloudinary.getUrl(imageId, scaledWidth);

          return `<img src="${src}" alt="${alt}">`;
        } catch (error) {
          console.warn(error.message);
          return match;
        }
      })
  );
}
